export const handleFileDownload = (e, fileDoc, fileName) => {
  e.preventDefault();

  try {
    const byteCharacters = atob(fileDoc);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const fileBlob = new Blob([byteArray]);
    const fileUrl = URL.createObjectURL(fileBlob);

    const downloadLink = document.createElement('a');
    downloadLink.href = fileUrl;
    downloadLink.download = fileName || 'downloaded_file'; // Use a default name if fileName is not available

    document.body.appendChild(downloadLink);
    downloadLink.click();

    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(fileUrl);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};

export const handleDeadCertificateDownload = async (e, base64Data, fileName) => {
  try {
    e.preventDefault();

    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const fileBlob = new Blob([byteArray], { type: 'image/*' });
    const fileUrl = URL.createObjectURL(fileBlob);
    const img = document.createElement('img');
    img.src = fileUrl;
    document.body.appendChild(img);
    const downloadLink = document.createElement('a');
    downloadLink.download = fileName;
    downloadLink.href = fileUrl;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    document.body.removeChild(img);
    URL.revokeObjectURL(fileUrl);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};

export const handleApprovalLetterDownload = async (e, base64Data, fileName) => {
  try {
    e.preventDefault();

    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const fileBlob = new Blob([byteArray], { type: 'image/*' });
    const fileUrl = URL.createObjectURL(fileBlob);
    const img = document.createElement('img');
    img.src = fileUrl;
    document.body.appendChild(img);
    const downloadLink = document.createElement('a');
    downloadLink.download = fileName;
    downloadLink.href = fileUrl;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    document.body.removeChild(img);
    URL.revokeObjectURL(fileUrl);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};

export function uuid4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  );
}
